<template>
    <div class="p-quantity">
        <vue-element-loading :active="atualizandoQuantidadeAcrescimo"/>
        <div class="btn-quantity">
            <MinusBox @click="subtrai(produto)" class="md-28 qb-txt-color-1" />
        </div>
        <div class="input-quantity">
            <input type="number" :value="produto.percentageAdd" name="quantity" @blur="inputAlterado(produto)" @keyup.enter="inputAlterado(produto)" @keydown.tab="inputAlterado(produto)" min="0" max="10">
        </div>
        <div class="btn-quantity">
            <PlusBox @click="incrementa(produto)" class="md-28 qb-txt-color-1"/>
        </div>
    </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading';
import PlusBox from "vue-material-design-icons/PlusBox.vue";
import MinusBox from "vue-material-design-icons/MinusBox.vue";
import axios from "axios";
import { baseApiUrl } from "@/global";
export default {
    components:{
        VueElementLoading,
        PlusBox,
        MinusBox
    },
    props:{
        produto: {
            required: true
        }
    },
    data(){
        return{
            atualizandoQuantidadeAcrescimo: false,
            acrescimoTemp: 0
        }
    },
    methods:{
        incrementa(produto){
            produto.percentageDiscountVendedor = 0;
            if(produto.percentageAdd >= 8){
                event.target.value = 8;
            }else if(event.target.value == 1){
                event.target.value = 2;
            }
            if(produto.percentageAdd < 8){
                this.acrescimoTemp = produto.percentageAdd;
                if(produto.percentageAdd == 0){
                    produto.percentageAdd = 2;    
                }else{
                    produto.percentageAdd++;
                }
                this.update(produto);
            }
            
        },
        subtrai(produto){
            produto.percentageDiscountVendedor = 0;
            if(produto.percentageAdd == 0) return
            if(event.target.value == 1 || produto.percentageAdd == 2){
                event.target.value = 0;
                this.acrescimoTemp = produto.percentageAdd;
                produto.percentageAdd = 0;
                this.update(produto);
                return;
            }
            this.acrescimoTemp = produto.percentageAdd;
            produto.percentageAdd--;
            this.update(produto);
        },
        inputAlterado(produto){
            produto.percentageDiscountVendedor = 0;
            if(event.target.value <= 1){
                event.target.value = 0;
            }else if(event.target.value > 8){
                event.target.value = 8;
            }
            if(event.target.value != produto.percentageAdd && event.target.value <= 8){
                this.acrescimoTemp = produto.percentageAdd;
                produto.percentageAdd = parseInt(event.target.value)
                this.update(produto);
            }
        }, 
        update(produto){
            this.atualizandoQuantidadeAcrescimo=true;
            const obj = JSON.parse(localStorage.getItem('cliente_vinculado'));

            axios.put(`${ baseApiUrl }/orders/` + (obj ? `?clientId=${obj.id}` : ''),produto )
                .then(res => {
                    if(res.data.valid){
                        this.$awn.success(res.data.message, {labels: {success: res.data.title }})
                        this.$emit('atualizaTotalAcrescimo');
                    }else{
                        this.$awn.warning(res.data.message, {labels: {warning: res.data.title }})
                        produto.percentageAdd = this.acrescimoTemp;
                    }
                    this.atualizandoQuantidadeAcrescimo=false
               })
                .catch(error => console.log(error))
                .finally(/*sempre executa*/)
        }
    },
    created(){
    }
}
</script>

<style scoped>
 .input-quantity input{
    width: 100%;
    font-size: 15px;
    border: none;
    border-bottom: 1px solid #efefefc2;
    text-align: center;
    padding-bottom: 4px;
}
.material-design-icon.md-28 {
  font-size: 30px;
  height: 0.85em;
}


.p-quantity{
    display: flex;
    height: 40px;
    width: 110px;
    justify-content: center;
    border: 1px solid #808080c2;
    border-radius: 10px;
    padding: 4px;
    margin: 0px 4px;
}

input[type=number] {
    -moz-appearance:textfield;
    height: 30px;
}
</style>